import { resolveLineShopId } from '@core/utils/cartLineUtils';
import type { CartItem } from '../types';
import type { GetProductsStockResponse } from '../graphql/types';

const TTL_MS = 30_000;

type StockCacheEntry = {
  at: number;
  byShop: Map<string, GetProductsStockResponse['mst_product']>;
};

let cache: { cartHash: string; entry: StockCacheEntry } | null = null;

export function cartStockHash(items: CartItem[]): string {
  return items
    .map(
      i =>
        `${i.productId}|${i.quantity}|${i.color ?? ''}|${i.size ?? ''}|${resolveShopFromItem(i)}`
    )
    .sort()
    .join(';');
}

function resolveShopFromItem(item: CartItem): string {
  return resolveLineShopId(item);
}

export function readCartStockSnapshot(
  cartHash: string,
  shopId: string
): GetProductsStockResponse['mst_product'] | null {
  if (!cache || cache.cartHash !== cartHash) return null;
  if (Date.now() - cache.entry.at > TTL_MS) {
    cache = null;
    return null;
  }
  return cache.entry.byShop.get(shopId) ?? null;
}

export function writeCartStockSnapshot(
  cartHash: string,
  shopId: string,
  rows: GetProductsStockResponse['mst_product']
): void {
  const now = Date.now();
  if (!cache || cache.cartHash !== cartHash || now - cache.entry.at > TTL_MS) {
    cache = {
      cartHash,
      entry: { at: now, byShop: new Map([[shopId, rows]]) },
    };
    return;
  }
  cache.entry.byShop.set(shopId, rows);
  cache.entry.at = now;
}

export function clearCartStockSnapshot(): void {
  cache = null;
}
